import { render, staticRenderFns } from "./ReceiveTimeForm.vue?vue&type=template&id=ceba4b8c&scoped=true"
import script from "./ReceiveTimeForm.vue?vue&type=script&lang=js"
export * from "./ReceiveTimeForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiveTimeForm.vue?vue&type=style&index=0&id=ceba4b8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceba4b8c",
  null
  
)

export default component.exports